/* tslint:disable */
/* eslint-disable */
/**
 * Swagger wiegaaterkoffiehalen
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.3.5
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type Drawing,
    DrawingFromJSON,
    DrawingToJSON,
} from '../models/Drawing';
import {
    type PlaceOrderBody,
    PlaceOrderBodyFromJSON,
    PlaceOrderBodyToJSON,
} from '../models/PlaceOrderBody';
import {
    type StartDrawingBody,
    StartDrawingBodyFromJSON,
    StartDrawingBodyToJSON,
} from '../models/StartDrawingBody';

export interface CloseDrawingRequest {
    /**
     * 
     */
    accessToken: string;
    /**
     * The ID of the group
     */
    id: string;
    /**
     * The ID of the drawing
     */
    drawingId: string;
}

export interface GetDrawingRequest {
    /**
     * 
     */
    accessToken: string;
    /**
     * The ID of the group
     */
    id: string;
    /**
     * The ID of the drawing
     */
    drawingId: string;
}

export interface PlaceOrderRequest {
    /**
     * 
     */
    accessToken: string;
    /**
     * The ID of the group
     */
    id: string;
    /**
     * The ID of the drawing
     */
    drawingId: string;
    /**
     * 
     */
    placeOrderBody: PlaceOrderBody;
}

export interface StartDrawingRequest {
    /**
     * 
     */
    accessToken: string;
    /**
     * The ID of the group
     */
    id: string;
    /**
     * 
     */
    startDrawingBody: StartDrawingBody;
}

/**
 * 
 */
export class GroupDrawingsApi extends runtime.BaseAPI {

    /**
     * Creates request options for closeDrawing without sending the request
     */
    async closeDrawingRequestOpts(requestParameters: CloseDrawingRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['accessToken'] == null) {
            throw new runtime.RequiredError(
                'accessToken',
                'Required parameter "accessToken" was null or undefined when calling closeDrawing().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling closeDrawing().'
            );
        }

        if (requestParameters['drawingId'] == null) {
            throw new runtime.RequiredError(
                'drawingId',
                'Required parameter "drawingId" was null or undefined when calling closeDrawing().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accessToken'] != null) {
            headerParameters['access-token'] = String(requestParameters['accessToken']);
        }


        let urlPath = `/groups/{id}/drawings/{drawingId}/close`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));
        urlPath = urlPath.replace('{drawingId}', encodeURIComponent(String(requestParameters['drawingId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Close drawing
     */
    async closeDrawingRaw(requestParameters: CloseDrawingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.closeDrawingRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Close drawing
     */
    async closeDrawing(requestParameters: CloseDrawingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.closeDrawingRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for getDrawing without sending the request
     */
    async getDrawingRequestOpts(requestParameters: GetDrawingRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['accessToken'] == null) {
            throw new runtime.RequiredError(
                'accessToken',
                'Required parameter "accessToken" was null or undefined when calling getDrawing().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getDrawing().'
            );
        }

        if (requestParameters['drawingId'] == null) {
            throw new runtime.RequiredError(
                'drawingId',
                'Required parameter "drawingId" was null or undefined when calling getDrawing().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accessToken'] != null) {
            headerParameters['access-token'] = String(requestParameters['accessToken']);
        }


        let urlPath = `/groups/{id}/drawings/{drawingId}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));
        urlPath = urlPath.replace('{drawingId}', encodeURIComponent(String(requestParameters['drawingId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get drawing
     */
    async getDrawingRaw(requestParameters: GetDrawingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Drawing>> {
        const requestOptions = await this.getDrawingRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DrawingFromJSON(jsonValue));
    }

    /**
     * Get drawing
     */
    async getDrawing(requestParameters: GetDrawingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Drawing> {
        const response = await this.getDrawingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for placeOrder without sending the request
     */
    async placeOrderRequestOpts(requestParameters: PlaceOrderRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['accessToken'] == null) {
            throw new runtime.RequiredError(
                'accessToken',
                'Required parameter "accessToken" was null or undefined when calling placeOrder().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling placeOrder().'
            );
        }

        if (requestParameters['drawingId'] == null) {
            throw new runtime.RequiredError(
                'drawingId',
                'Required parameter "drawingId" was null or undefined when calling placeOrder().'
            );
        }

        if (requestParameters['placeOrderBody'] == null) {
            throw new runtime.RequiredError(
                'placeOrderBody',
                'Required parameter "placeOrderBody" was null or undefined when calling placeOrder().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['accessToken'] != null) {
            headerParameters['access-token'] = String(requestParameters['accessToken']);
        }


        let urlPath = `/groups/{id}/drawings/{drawingId}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));
        urlPath = urlPath.replace('{drawingId}', encodeURIComponent(String(requestParameters['drawingId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PlaceOrderBodyToJSON(requestParameters['placeOrderBody']),
        };
    }

    /**
     * Place order
     */
    async placeOrderRaw(requestParameters: PlaceOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.placeOrderRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Place order
     */
    async placeOrder(requestParameters: PlaceOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.placeOrderRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for startDrawing without sending the request
     */
    async startDrawingRequestOpts(requestParameters: StartDrawingRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['accessToken'] == null) {
            throw new runtime.RequiredError(
                'accessToken',
                'Required parameter "accessToken" was null or undefined when calling startDrawing().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling startDrawing().'
            );
        }

        if (requestParameters['startDrawingBody'] == null) {
            throw new runtime.RequiredError(
                'startDrawingBody',
                'Required parameter "startDrawingBody" was null or undefined when calling startDrawing().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['accessToken'] != null) {
            headerParameters['access-token'] = String(requestParameters['accessToken']);
        }


        let urlPath = `/groups/{id}/drawings`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StartDrawingBodyToJSON(requestParameters['startDrawingBody']),
        };
    }

    /**
     * Start drawing
     */
    async startDrawingRaw(requestParameters: StartDrawingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.startDrawingRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Start drawing
     */
    async startDrawing(requestParameters: StartDrawingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.startDrawingRaw(requestParameters, initOverrides);
    }

}
